export default __webpack_public_path__ + "static/media/CommonMetalsTableImg.c5daae52.jpg";